import React from 'react';
import ReactDOM from 'react-dom';
import './styles/main.scss';
import 'react-image-lightbox/style.css';
import App from './app';
import {FeatureContext} from "./contexts/feature";

import {library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';

library.add(fab, fas, far)

ReactDOM.render(
    <React.StrictMode>
        <FeatureContext.Provider value={checkFeatures()}>
            <App/>
        </FeatureContext.Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

function checkFeatures() {
    return {
        serviceWorker: 'serviceWorker' in navigator,
        pushManager: 'PushManager' in window,
    }
}